import Cookie from 'js-cookie';
import { useEffect, useState } from 'react';

export const useBetaCookie = ({ cookieName }: { cookieName: string }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const cookie = Cookie.get(cookieName);
    // if cookie exists, but has no value js-cookie returns 'undefined'.
    if (cookie || cookie === 'undefined') {
      setEnabled(true);
    }
  }, []);

  return {
    enabled,
    enableBeta: () => {
      Cookie.set(cookieName, 'true');
      setEnabled(true);
      window.location.reload();
    },
    disableBeta: () => {
      Cookie.remove(cookieName);
      setEnabled(false);
      window.location.reload();
    },
  };
};
